import styled from "@emotion/styled";

export const StyledActivities = styled.div`
  .activity-item {
    padding: 16px 0;
    align-items: flex-start;
  }

  .ant-list-item-meta-avatar {
    margin-inline-end: 8px !important;
  }
  .activity-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    .activity-left {
      display: flex;
      align-items: baseline;
      gap: 5px;

      .activity-date {
        display: block;
        font-size: 12px;
      }
    }
  }

  .activity-body {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .activity-change {
    max-width: 50%;
  }

  .activity-arrow {
    font-size: 18px;
    color: #999;
    font-weight: 600;
  }
`;
